import {
  ApiResult,
  ApiSuccessResult,
  apiCall,
} from "@/common/api/ApiResult.model";
import { ScanSession } from "@/views/customize/data-sources/data/model";
import {
  PermissionCounter,
  FilesScanItem,
  PermissionMainType,
  PermissionSubType,
  PermissionsLabelIds,
  FileScanStatus,
} from "./models";
import { ICONS } from "@/common/icons.map";
import { SharedState } from "@/common/state";
import { InformationType } from "@/common/models";
import * as mock_data from "./data.mock";
import { memoize } from "@/fp";
import {
  get_finding_count,
  get_finding_entities,
} from "@/common/api/findings/findings.api";
import axios from "axios";
import { FindingType } from "@/common/api/findings/findings.model";

const mock_counters = memoize((key: string): number => {
  return Math.floor(Math.random() * 20) + 1;
});

const get_scan_status_for_sp_permission_and_session = apiCall<
  { permission_levels: string[]; session_id: number; finding: FindingType },
  Record<string, FileScanStatus>
>(
  "sp-permissions.status-for-label",
  async ({ permission_levels, session_id }) => {
    /*  const res = await axios.get("/");
    return {
      success: true,
      value: res.data,
    }; */
    return {
      success: true,
      value: Object.keys(PermissionsLabelIds).reduce((acc, id) => {
        acc[id] = "not_started";
        return acc;
      }, {} as Record<string, FileScanStatus>),
    };
  }
);

export const get_sp_permissions_counts_and_status = async (
  session_id: number
): Promise<ApiResult<PermissionCounter[]>> => {
  const res = await get_finding_count({
    service: "sp_site_permission",
    application: "msft_sharepoint_365",
    label_ids: Object.keys(PermissionsLabelIds),
    type: "sp_site_permission",
    axis_z: {
      type: "Session",
      value: session_id,
    },
  });
  if (res.success) {
    console.log("get_sp_permissions_counts_and_status:", res);
    const status_res = await get_scan_status_for_sp_permission_and_session({
      finding: "sp_site_permission",
      permission_levels: Object.keys(PermissionsLabelIds),
      session_id: session_id,
    });
    if (status_res.success) {
      return {
        success: true,
        value: (res as ApiSuccessResult<
          {
            labelId: string;
            count: number;
          }[]
        >).value.map((d) => {
          return {
            id: d.labelId,
            type: PermissionsLabelIds[d.labelId],
            count: d.count,
            files_scan_status: status_res.value[d.labelId],
          };
        }),
      };
    } else {
      return status_res;
    }
  } else {
    return res;
  }
};

// @ts-ignore
window.get_sp_permissions_counts_and_status = get_sp_permissions_counts_and_status;

export const get_sites_for_permmission_level = async (
  permission_level: string,
  session_id: number,
  cursor: string
) => {
  const res = await get_finding_entities("SharepointWebsite")({
    cursor,
    service: "sp_site_permission",
    application: "msft_sharepoint_365",
    label_ids: [permission_level],
    type: "sp_site_permission",
    axis_z: {
      type: "Session",
      value: session_id,
    },
  });
};

export const get_files_scan_results = async (payload: {
  scan: ScanSession;
  labels: InformationType[];
  type: PermissionMainType;
  sub_type: PermissionSubType;
}): Promise<ApiResult<FilesScanItem[]>> => {
  console.log("get_files_scan_results : ", payload);
  return {
    success: true,
    value: payload.labels.map((label) => {
      return {
        label: {
          id: label.id,
          name: label.labelName,
          icon: ICONS.L0_ICONS.get(label.code),
        },
        files_count: mock_data.get_files_count_for_l0(label.code),
        sites_count: mock_counters(
          payload.type + payload.sub_type + label.code
        ),
      };
    }),
  };
};
